import { storefrontAiDe } from './storefront.ai.de';
import { storefrontNeedsDe } from './storefront.needs.de';
/** Vitrin arayüz metinleri (de). Vitrinin istemci paketi yalnızca bunu ve ortak/hata metinlerini yükler (F7-17). */
export const storefrontDe = {
  google: {
    or: 'oder',
    continue: 'Weiter mit Google',
    signUpTitle: 'Mit Google registrieren',
    newAccount: 'Mit dem Google-Konto {{email}} wird ein neues Konto erstellt.',
    name: 'Name: {{name}}',
    noPassword:
      'Ihr Konto wird ohne Passwort erstellt; Sie können jederzeit unter Mein Konto → Verknüpfte Konten eines festlegen.',
    createAccount: 'Konto erstellen',
    linkedTitle: 'Verknüpfte Konten',
    linked: 'Google: {{email}}',
    setPasswordFirst:
      'Legen Sie ein Passwort fest, bevor Sie die Google-Verknüpfung entfernen; sonst können Sie sich nicht anmelden.',
    newPassword: 'Neues Passwort',
    setPassword: 'Passwort festlegen',
    passwordSet: 'Ihr Passwort wurde festgelegt.',
    unlink: 'Google-Verknüpfung entfernen',
    unlinkConfirm: 'Google-Verknüpfung entfernen? Danach melden Sie sich mit E-Mail und Passwort an.',
    unlinked: 'Google-Verknüpfung entfernt.',
    reauth: 'Erneut mit Google anmelden',
  },
  ai: storefrontAiDe,
  needsFinder: storefrontNeedsDe,
  brands: 'Marken',
  suggest: {
    label: 'Suchvorschläge',
    groups: {
      products: 'Produkte',
      categories: 'Kategorien',
      brands: 'Marken',
      all: 'Alle Ergebnisse',
    },
    all: 'Alle Ergebnisse für "{{q}}" ({{count}})',
    status: '{{count}} Vorschläge. Mit der Pfeiltaste nach unten auswählen.',
    none: 'Keine Vorschläge. Drücken Sie die Eingabetaste, um zu suchen.',
  },
  quick: {
    view: 'Schnellansicht: {{title}}',
    viewShort: 'Schnellansicht',
    add: 'In den Warenkorb: {{title}}',
    addShort: 'In den Warenkorb',
    title: 'Schnellansicht',
    close: 'Schließen',
    details: 'Zur Produktseite',
    loading: 'Wird geladen…',
    failed: 'Das Produkt konnte nicht geladen werden. Öffnen Sie die Produktseite.',
  },
  filters: {
    open: 'Filter',
    title: 'Filter',
    close: 'Schließen',
    form: 'Produktfilter',
    brand: 'Marke',
    price: 'Preis ({{currency}})',
    priceMin: 'Min.',
    priceMax: 'Max.',
    stock: 'Verfügbarkeit',
    inStockOnly: 'Nur vorrätige Artikel',
    discount: 'Rabatt',
    discountedOnly: 'Reduzierte Produkte',
    active: 'Ausgewählte Filter',
    remove: 'Filter entfernen: {{name}}',
    clearAll: 'Alle löschen',
    below: 'unter {{max}}',
    above: 'ab {{min}}',
    range: '{{min}}–{{max}}',
    priceChip: 'Preis: {{range}}',
    option: '{{label}} ({{count}})',
  },
  preparingTitle: 'Unser neuer Shop ist bald da',
  preparingLead:
    'Diese Website befindet sich im Aufbau. Wir sind hier für Sie da, sobald Bestellungen möglich sind.',
  brandsLabel: 'Unsere Marken',
  contactLater: 'Kontakt- und Verkäuferangaben werden vor dem Start auf dieser Seite veröffentlicht.',
  unknownDomainTitle: 'Unter dieser Adresse gibt es noch keinen Shop',
  unknownDomainLead:
    'Die Domain erreicht den Server, ist aber mit keinem Shop verbunden. Öffnen Sie in der Verwaltung den Bereich Shops und fügen Sie diese Domain hinzu.',
  unavailableTitle: 'Der Shop antwortet gerade nicht',
  unavailableLead:
    'Möglicherweise handelt es sich um eine kurze Wartung oder ein Verbindungsproblem. Bitte versuchen Sie es in einigen Minuten erneut.',
  notFoundTitle: 'Seite nicht gefunden',
  notFoundLead:
    'Die Adresse hat sich möglicherweise geändert oder die Seite wurde entfernt. Durchsuchen Sie unsere Produkte oder nutzen Sie die Links unten.',
  notFoundSearch: 'Produkte durchsuchen',
  notFoundHome: 'Startseite',
  goneTitle: 'Diese Seite wurde entfernt',
  goneLead: 'Die gesuchte Seite wurde dauerhaft entfernt.',
  maintenanceTitle: 'Wir führen eine kurze Wartung durch',
  maintenanceLead: 'Der Shop ist in Kürze wieder geöffnet.',
  acceptMembership:
    'Ich habe die Mitgliedschaftsbedingungen und die Datenschutzhinweise gelesen und akzeptiere sie.',
  acceptSalesTerms:
    'Ich habe das Vorabinformationsformular und den Fernabsatzvertrag gelesen und akzeptiere sie.',
  activateTitle: 'Aktivieren Sie Ihr Konto',
  activateLead: 'Hallo {{name}}, Ihr Konto wurde vom Shop angelegt. Legen Sie Ihr Passwort fest.',
  resetLead: 'Hallo {{name}}, legen Sie Ihr neues Passwort fest.',
  addToCart: 'In den Warenkorb',
  buyNow: 'Jetzt kaufen',
  added: 'Zum Warenkorb hinzugefügt.',
  all: 'Alle',
  allProducts: 'Alle Produkte',
  pageTitleNumbered: '{{title}} – Seite {{page}}',
  allSpecies: 'Alle',
  applicationPending: 'Ihre Händlerbewerbung wird geprüft.',
  applicationReceived:
    'Ihre Bewerbung ist eingegangen. Wir teilen Ihnen das Ergebnis per E-Mail mit; den Status können Sie auch unter Mein Konto verfolgen.',
  applicationRejected: 'Ihre vorherige Bewerbung wurde nicht angenommen.',
  apply: 'Anwenden',
  applyCoupon: 'Einlösen',
  applyDealer: 'Händlerbewerbung',
  applyLead:
    'Wenn Sie eine Tierarztpraxis, ein Zoofachgeschäft oder eine Apotheke sind, können Sie sich als Händler bewerben. Nach der Freigabe sehen Sie nach der Anmeldung die Händlerpreise.',
  applySignInFirst: 'Melden Sie sich an oder erstellen Sie ein Konto, um sich zu bewerben.',
  awaitingPaymentNote: 'Ihre Bestellung wartet auf Zahlung.',
  breadcrumb: 'Navigationspfad',
  cart: 'Warenkorb',
  cartEmpty: 'Ihr Warenkorb ist leer.',
  cartWithCount: 'Warenkorb, {{count}} Artikel',
  speciesProperty: 'Tierart',
  speciesNames: {
    cat: 'Katze',
    dog: 'Hund',
    bird: 'Vogel',
    rodent: 'Kleinnager',
    rabbit: 'Kaninchen',
    reptile: 'Reptilien und Schildkröten',
    exotic: 'Andere Exoten',
  },
  categories: 'Kategorien',
  changePassword: 'Passwort ändern',
  checkout: 'Zur Kasse',
  chooseOption: 'Wählen Sie eine Option.',
  consents: 'Marketingnachrichten',
  privacy: {
    title: 'Meine personenbezogenen Daten',
    lead: 'Hier können Sie Ihre Rechte bezüglich Ihrer personenbezogenen Daten (KVKK Art. 11) wahrnehmen. Details:',
    noticeLink: 'Datenschutzhinweise',
    exportTitle: 'Meine Daten herunterladen',
    exportLead:
      'Eine Kopie Ihres Kontos, Ihrer Adressen, Bestellungen, Einwilligungen und weiterer Datensätze wird sofort als JSON-Datei heruntergeladen.',
    password: 'Ihr Passwort',
    export: 'Meine Daten herunterladen',
    exported: 'Ihre Daten wurden heruntergeladen.',
    erasureTitle: 'Mein Konto löschen',
    erasureLead:
      'Ihr Löschantrag wird innerhalb von 30 Tagen bearbeitet und Sie werden per E-Mail benachrichtigt. Ihr Konto wird geschlossen; Ihre Adressen, Favoriten und Kontaktdaten werden gelöscht. Bestell- und Rechnungsdaten werden für die gesetzlich vorgeschriebene Dauer aufbewahrt. Wenn Sie eine offene Bestellung haben, wird der Antrag nach deren Zustellung bearbeitet.',
    reason: 'Anmerkung (optional)',
    understood:
      'Mir ist bewusst, dass mein Konto geschlossen wird und dies nicht rückgängig gemacht werden kann.',
    requestErasure: 'Löschantrag senden',
    erasureSent: 'Ihr Löschantrag ist eingegangen. Wir teilen Ihnen das Ergebnis per E-Mail mit.',
    erasureOpen:
      'Sie haben einen offenen Löschantrag; Sie werden per E-Mail benachrichtigt, sobald er bearbeitet ist.',
    myRequests: 'Meine Anträge',
    dueBy: 'bis {{date}}',
    kinds: {
      export: 'Datenkopie',
      erasure: 'Löschung',
      info: 'Auskunftsersuchen',
      rectification: 'Berichtigung',
      objection: 'Widerspruch',
      other: 'Sonstiges',
    },
    statuses: {
      received: 'Eingegangen',
      in_progress: 'In Bearbeitung',
      completed: 'Abgeschlossen',
      rejected: 'Nicht angenommen',
    },
  },
  consentsNote: 'Bestell- und Versandbenachrichtigungen werden unabhängig von diesen Einstellungen gesendet.',
  coupon: 'Gutscheincode',
  createAccount: 'Konto erstellen',
  currentPassword: 'Aktuelles Passwort',
  dealerBar: 'Es werden Händlerpreise angezeigt ({{company}}).',
  dealerOf: 'Sie sind als Händler von {{company}} angemeldet und sehen Händlerpreise.',
  dealerPrice: 'Händlerpreis',
  dealership: 'Händlerschaft',
  discount: 'Rabatt ({{code}})',
  documents: 'Dokumente (Steuerbescheinigung usw.)',
  documentsHint: 'PDF, JPEG oder PNG; max. 10 MB. Nur Mitarbeitende des Shops können sie sehen.',
  email: 'E-Mail',
  emailNotVerified: 'E-Mail nicht bestätigt',
  emailVerified: 'Ihre E-Mail-Adresse ist bestätigt.',
  feedRegistration: 'Futtermittel-Registriernummer: {{no}}',
  feedRegistrationProperty: 'Futtermittel-Registriernummer',
  countryRegistration: 'Registrier- / Zulassungsnummer ({{country}}): {{no}}',
  notInCountry:
    'Dieses Produkt wird in dem von Ihnen gewählten Land nicht verkauft. Sie können in der oberen Leiste ein anderes Land wählen.',
  itemNotInCountry:
    'Dieses Produkt wird im gewählten Land nicht verkauft; entfernen Sie es oder ändern Sie das Land.',
  marketLabel: 'Land und Währung',
  languageLabel: 'Sprache',
  marketOption: '{{name}} ({{currency}})',
  forSpecies: 'Geeignet für: {{list}}',
  forgot: 'Passwort vergessen',
  forgotTitle: 'Passwort vergessen',
  from: 'ab',
  fullName: 'Vollständiger Name',
  goToCart: 'Zum Warenkorb',
  homeLead: 'Nahrungsergänzung für Katzen und Hunde.',
  itemInsufficient: 'Nur noch {{count}} auf Lager.',
  itemUnavailable: 'Dieses Produkt ist nicht mehr erhältlich; entfernen Sie es aus dem Warenkorb.',
  leaflet: 'Produktinformationen',
  loading: 'Wird geladen…',
  lowStock: 'Nur noch {{count}} verfügbar',
  lowest30: 'Niedrigster Preis der letzten 30 Tage: {{price}}',
  discountPercent: '{{n}} % Rabatt',
  marketingEmail: 'Ich möchte E-Mails zu Aktionen erhalten.',
  marketingLegend: 'Optionale Marketing-Einwilligungen',
  marketingSms: 'Ich möchte SMS zu Aktionen erhalten.',
  menu: 'Menü',
  mainMenu: 'Hauptmenü',
  faq: 'Häufig gestellte Fragen',
  pagePreviewNotice:
    'Seitenvorschau: Sie sehen den unveröffentlichten Entwurf. Dieser Link ist nur für Sie bestimmt.',
  menuSeeAll: 'Alle: {{label}}',
  homeCrumb: 'Startseite',
  qaTitle: 'Fragen und Antworten',
  reviews: {
    title: 'Bewertungen',
    empty:
      'Für dieses Produkt gibt es noch keine Bewertungen. Kunden, die es gekauft und erhalten haben, können eine Bewertung schreiben.',
    count: '{{count}} Bewertungen',
    outOf: '{{value}} von 5',
    stars: '{{n}} Sterne',
    distribution: 'Verteilung der Bewertungen',
    verified: 'Verifizierter Kauf',
    storeReply: 'Antwort von {{store}}',
    by: '{{name}}',
    sort: 'Sortieren',
    sorts: {
      newest: 'Neueste',
      rating_desc: 'Beste Bewertung',
      rating_asc: 'Schlechteste Bewertung',
    },
    more: 'Weitere Bewertungen anzeigen',
    write: 'Bewertung schreiben',
    signIn: 'Melden Sie sich an, um eine Bewertung zu schreiben',
    notPurchased:
      'Sie können dieses Produkt bewerten, nachdem Sie es in diesem Shop gekauft und erhalten haben.',
    alreadyReviewed: 'Sie haben dieses Produkt bereits bewertet, vielen Dank.',
    rating: 'Ihre Bewertung',
    ratingNames: {
      '1': 'Sehr schlecht',
      '2': 'Schlecht',
      '3': 'Durchschnittlich',
      '4': 'Gut',
      '5': 'Ausgezeichnet',
    },
    reviewTitle: 'Titel',
    optional: 'optional',
    body: 'Ihr Erfahrungsbericht',
    bodyHint:
      'Mindestens 20 Zeichen. Beschreiben Sie, wie Sie das Produkt verwendet haben; geben Sie keine personenbezogenen Daten, Gesundheitsaussagen oder Krankheitsnamen an. Nach der Freigabe wird die Bewertung mit Ihrem Vornamen und dem Anfangsbuchstaben Ihres Nachnamens veröffentlicht.',
    submit: 'Bewertung absenden',
    sent: 'Vielen Dank. Ihre Bewertung wird nach der Freigabe auf der Produktseite veröffentlicht.',
  },
  qaEmpty: 'Zu diesem Produkt gibt es noch keine beantworteten Fragen.',
  qaAsk: 'Frage stellen',
  qaLabel: 'Ihre Frage',
  qaHint:
    'Ihre Frage wird nach Prüfung zusammen mit der Antwort auf dieser Seite veröffentlicht; es wird nur eine Kurzform Ihres Namens angezeigt. Geben Sie keine persönlichen Daten wie Telefonnummer oder Adresse an.',
  qaSubmit: 'Frage senden',
  qaSentNotify: 'Ihre Frage ist eingegangen. Wir benachrichtigen Sie per E-Mail, sobald sie beantwortet ist.',
  qaSent: 'Ihre Frage ist eingegangen. Sie wird hier veröffentlicht, sobald sie beantwortet ist.',
  qaSignIn: 'Melden Sie sich an, um eine Frage zu stellen',
  qaAsked: 'Gefragt von {{name}}',
  qaAnswered: 'Beantwortet von {{store}}',
  compare: 'Vergleichen',
  compareTitle: 'Produktvergleich',
  compareAdd: 'Zum Vergleich hinzufügen',
  compareRemove: 'Aus dem Vergleich entfernen',
  compareFull: 'Es können bis zu 4 Produkte verglichen werden.',
  compareBar: '{{count}} Produkte im Vergleich',
  compareClear: 'Liste leeren',
  compareEmpty:
    'Verwenden Sie zum Vergleichen die Schaltfläche "Zum Vergleich hinzufügen" auf den Produktseiten (bis zu 4 Produkte).',
  compareShare: 'Teilen Sie die Adresse dieser Seite, um den Vergleich an andere zu senden.',
  compareMissing: '{{count}} Produkte sind nicht mehr im Verkauf und werden nicht angezeigt.',
  compareTable: 'Merkmale der ausgewählten Produkte',
  compareRemoveOne: 'Entfernen: {{title}}',
  compareScroll: 'Vergleichstabelle (horizontal scrollbar)',
  compareRows: {
    product: 'Produkt',
    price: 'Preis',
    unitPrice: 'Grundpreis',
    net: 'Nettomenge',
    species: 'Geeignet für',
    composition: 'Zusammensetzung',
    usage: 'Anwendung',
  },
  netUnits: {
    g: '{{n}} g',
    ml: '{{n}} ml',
    piece: '{{n}} Stk.',
  },
  notSpecified: 'Nicht angegeben',
  favoriteAdd: 'Zu Favoriten hinzufügen',
  favoriteRemove: 'Aus Favoriten entfernen',
  favoriteLogin: 'Melden Sie sich an, um Favoriten hinzuzufügen',
  favoriteError: 'Der Vorgang konnte nicht abgeschlossen werden; bitte versuchen Sie es erneut.',
  favorites: 'Meine Favoriten',
  favoritesEmpty: 'Noch keine Favoriten. Fügen Sie Produkte mit dem Herz-Symbol auf den Produktkarten hinzu.',
  favoritesHidden:
    '{{count}} Lieblingsprodukte sind derzeit nicht im Verkauf; sie erscheinen hier wieder, sobald sie verfügbar sind.',
  favoritesCount: '{{count}} Produkte',
  favoritesSignIn: 'Melden Sie sich an, um Ihre Favoriten zu sehen.',
  relatedProducts: 'Ähnliche Produkte',
  galleryLabel: 'Produktbilder',
  galleryShow: 'Bild {{n}} anzeigen',
  galleryZoom: 'Bild vergrößern',
  galleryClose: 'Schließen',
  galleryPrev: 'Vorheriges Bild',
  galleryNext: 'Nächstes Bild',
  galleryPosition: '{{n}} / {{total}}',
  complementaryProducts: 'Passt gut dazu',
  share: 'Teilen',
  shareCopied: 'Link kopiert.',
  shareFailed: 'Der Link konnte nicht kopiert werden; kopieren Sie ihn aus der Adressleiste.',
  gtin: 'Barcode (GTIN): {{gtin}}',
  installments: 'Bis zu {{n}} Raten per Kreditkarte (abhängig von Karte und Bank)',
  returnInfo: {
    title: 'Rückgabe',
    days: 'Rückgabe innerhalb von {{days}} Tagen nach Lieferung möglich.',
    by_mail: 'Die Rückgabe erfolgt per Versand.',
    in_store: 'Die Rückgabe erfolgt im Geschäft.',
    by_mail_or_in_store: 'Die Rückgabe erfolgt per Versand oder im Geschäft.',
    free: 'Der Rückversand ist kostenlos.',
    customer_pays: 'Die Kosten des Rückversands trägt der Käufer.',
    link: 'Rückgabe- und Widerrufsbedingungen (einschließlich Ausnahmen)',
  },
  shippingInfo: {
    title: 'Versand und Lieferung',
    free: 'Kostenlos',
    price: 'Versand: {{price}}',
    freeOver: 'Kostenlos ab einem Bestellwert von {{price}}',
    delivery: 'Voraussichtliche Lieferung: {{range}}',
    days: 'Lieferzeit: {{days}}',
    cod: 'Nachnahme möglich',
    note: 'Das Lieferdatum ist eine Schätzung und kann sich an Feiertagen verlängern. Die genauen Versandkosten werden im Warenkorb berechnet.',
  },
  tableOfContents: 'Inhalt',
  videos: {
    play: 'Video abspielen: {{title}}',
    notice: 'Das Video wird von {{provider}} geladen; {{provider}} kann beim Abspielen Cookies verwenden.',
    providers: {
      youtube: 'YouTube',
      vimeo: 'Vimeo',
    },
  },
  documentKinds: {
    analysis_certificate: 'Analysezertifikat',
    leaflet: 'Gebrauchsanweisung',
    safety_data_sheet: 'Sicherheitsdatenblatt',
    registration: 'Registrierung / Zulassung',
    other: 'Dokument',
  },
  documentSize: 'PDF, {{size}}',
  subcategories: 'Unterkategorien',
  relatedCategories: 'Verwandte Kategorien',
  productCategories: 'Kategorien dieses Produkts',
  seoFallback: {
    home: '{{store}}: {{categories}}. Inhaltsstoffe, Anwendungshinweise, Artikel und Verkaufsstellen.',
    homeNoCategories: 'Onlineshop {{store}}: Inhaltsstoffe, Anwendungshinweise, Artikel und Verkaufsstellen.',
    products:
      'Alle Produkte von {{store}}: nach Tierart, Kategorie, Marke und Preis filtern; Inhaltsstoffe und Anwendung ansehen.',
    category:
      '{{name}} — {{store}}. Inhaltsstoffe, Anwendungshinweise und aktuelle Preise der Produkte dieser Kategorie.',
    brand: 'Alle Produkte von {{name}}: Inhaltsstoffe, Anwendungshinweise und aktuelle Preise.',
    brands: 'Marken bei {{store}} und die Produkte jeder Marke.',
    blog: 'Artikel von {{store}} zu Pflege und Ernährung von Haustieren.',
    contact: 'Kontakt zu {{store}}: Kontaktformular und Anbieterinformationen.',
    legal: '{{store}} {{title}}: die aktuell gültige Fassung.',
    bankAccounts: 'Bankverbindungen von {{store}}: Konto- und IBAN-Angaben für die Zahlung per Überweisung.',
  },
  llms: {
    categories: 'Kategorien',
    pages: 'Seiten',
    legal: 'Rechtstexte',
    products: 'Alle Produkte',
    articles: 'Artikel',
    salesPoints: 'Verkaufsstellen',
    contact: 'Kontakt',
    sitemap: 'Sitemap',
    productList: 'Produkte',
    articleList: 'Neueste Artikel',
  },
  blog: 'Artikel',
  blogEmpty: 'Es wurden noch keine Beiträge veröffentlicht.',
  blogAll: 'Alle',
  blogCategories: 'Artikelkategorien',
  blogPages: 'Blog-Seiten',
  blogArchive: 'Archiv',
  blogArchiveTitle: 'Artikelarchiv: {{period}}',
  blogArchiveCount: 'Beiträge: {{count}}',
  blogArchiveYear: 'Beiträge aus {{year}}',
  readingTime: '{{n}} Min. Lesezeit',
  publishedOn: 'Veröffentlicht: {{date}}',
  updatedOn: 'Aktualisiert: {{date}}',
  byAuthor: 'Von {{name}}',
  postReferences: 'Quellen',
  postProducts: 'Produkte in diesem Beitrag',
  postTags: 'Schlagwörter',
  postHealthNotice:
    'Dieser Artikel dient nur der Information und ersetzt keine Untersuchung, Diagnose oder Behandlung. Wenden Sie sich bei Fragen zur Gesundheit Ihres Tieres an Ihre Tierärztin oder Ihren Tierarzt.',
  postPreviewNotice:
    'Beitragsvorschau: Sie sehen den unveröffentlichten Entwurf. Dieser Link ist nur für Sie bestimmt.',
  allPosts: 'Alle Beiträge',
  sliderLabel: 'Highlights',
  bannerGridLabel: 'Aktionen',
  sliderRole: 'Karussell',
  slideRole: 'Folie',
  slidePosition: '{{n}} von {{total}}',
  slidePrev: 'Vorherige Folie',
  slideNext: 'Nächste Folie',
  slideGoTo: 'Zu Folie {{n}}',
  sliderPause: 'Rotation anhalten',
  sliderPlay: 'Rotation starten',
  announcement: 'Ankündigung',
  popupClose: 'Schließen',
  opensInNewTab: '(öffnet in einem neuen Tab)',
  links: 'Links',
  myAccount: 'Mein Konto',
  myOrders: 'Meine Bestellungen',
  newPassword: 'Neues Passwort',
  newest: 'Neue Produkte',
  next: 'Weiter',
  prev: 'Zurück',
  noOrders: 'Sie haben noch keine Bestellungen.',
  noPrice: 'Dieses Produkt ist derzeit nicht im Verkauf.',
  noProducts: 'Hier gibt es noch keine Produkte.',
  noResults: 'Keine Produkte entsprechen Ihrer Suche.',
  offlinePaymentNote:
    'Online-Zahlung ist noch nicht verfügbar: Ihre Bestellung wird als "Zahlung ausstehend" aufgenommen und der Shop kontaktiert Sie wegen der Zahlung.',
  orderNo: 'Bestellnr.',
  orderNote: 'Bestellnotiz (optional)',
  orderPlaced: 'Ihre Bestellung wurde aufgegeben: {{number}}',
  orderPlacedLead: 'Der Shop kontaktiert Sie wegen Zahlung und Lieferung.',
  orderTitle: 'Bestellung {{number}}',
  outOfStock: 'Nicht vorrätig',
  pageOf: 'Seite {{page}} von {{pages}}',
  pages: 'Seiten',
  password: 'Passwort',
  passwordChanged: 'Ihr Passwort wurde geändert; andere Sitzungen wurden abgemeldet.',
  passwordHint: 'Mindestens 12 Zeichen; wählen Sie einen schwer zu erratenden Satz.',
  birthdayOptional: 'Geburtstag (optional)',
  birthdayMonth: 'Monat',
  birthdayDay: 'Tag',
  birthdayHint:
    'Wird nur verwendet, um Ihnen eine Geburtstags-E-Mail zu senden (sofern Sie E-Mails erlauben); das Jahr wird nicht abgefragt. Sie können das Feld leer lassen oder jederzeit löschen.',
  phoneOptional: 'Telefon (optional)',
  placeOrder: 'Bestellung aufgeben ({{total}})',
  previewNotice: 'Vorschau: Der Shop ist noch nicht live.',
  themePreviewNotice:
    'Theme-Vorschau: Sie sehen den unveröffentlichten Entwurf. Besucher sehen das Live-Theme.',
  themePreviewExit: 'Vorschau beenden',
  shopBySpecies: 'Nach Tierart einkaufen',
  closeMenu: 'Menü schließen',
  designPreviewNotice:
    'Sie sehen eine Vorschau von Design {{variant}} für {{experience}}. Besucher sehen das veröffentlichte Design.',
  designPreviewExit: 'Vorschau beenden',
  designExperiences: {
    header: 'Hauptmenü',
    articles: 'Artikel',
    store_locator: 'Verkaufsstellen',
    needs_finder: 'Was mein Tier braucht',
  },
  articles: {
    featured: 'Empfohlen',
    latest: 'Neueste',
    latestArticles: 'Neueste Artikel',
    seeCategory: 'Alle in {{category}}',
    searchLabel: 'Artikel durchsuchen',
    searchPlaceholder: 'Artikel durchsuchen',
    resultsTitle: 'Artikel zu „{{q}}“',
    resultCount: '{{count}} Artikel gefunden',
    noResults: 'Keine Artikel passen zu Ihrer Suche. Versuchen Sie ein anderes Wort.',
    allArticles: 'Alle Artikel',
    count: '{{count}} Artikel',
  },
  locator: {
    title: 'Verkaufsstellen',
    metaDescription:
      'Händler und Geschäfte mit unseren Produkten nach Provinz, Bezirk und Viertel finden: Adresse, Telefon, Route und Öffnungszeiten.',
    cityTitle: 'Verkaufsstellen in {{city}}',
    cityDescription: 'Verkaufsstellen in {{city}} ({{count}}): Adresse, Telefon, Route und Öffnungszeiten.',
    districtTitle: 'Verkaufsstellen in {{district}}, {{city}}',
    districtDescription: 'Verkaufsstellen in {{district}}, {{city}} ({{count}}): Adresse, Telefon und Route.',
    city: 'Provinz',
    district: 'Bezirk',
    neighbourhood: 'Viertel',
    allCities: 'Alle Provinzen',
    allDistricts: 'Alle Bezirke',
    allNeighbourhoods: 'Alle Viertel',
    chooseCityFirst: 'Zuerst Provinz wählen',
    optionCount: '{{name}} ({{count}})',
    search: 'Nach Name oder Adresse suchen',
    searchPlaceholder: 'Geschäftsname, Viertel, Straße',
    useLocation: 'Meinen Standort verwenden',
    geoLocating: 'Standort wird ermittelt…',
    geoClear: 'Entfernungssortierung aufheben',
    geoPrivacy:
      'Ihr Standort wird nur auf diesem Gerät zum Sortieren der nächsten Verkaufsstellen verwendet und nicht an uns gesendet.',
    geoOk: 'Die nächsten Verkaufsstellen stehen oben. Ihr Standort hat dieses Gerät nicht verlassen.',
    geoDenied: 'Keine Standortfreigabe. Sie können nach Provinz und Bezirk suchen.',
    geoUnavailable: 'Standort konnte nicht ermittelt werden. Sie können nach Provinz und Bezirk suchen.',
    count: '{{count}} Verkaufsstellen',
    results: 'Verkaufsstellen',
    noMatch: 'Keine Verkaufsstelle passt zu Ihrer Auswahl.',
    noPoints: 'Noch keine Verkaufsstellen gelistet. Sie können unsere Produkte online bestellen.',
    clearFilters: 'Filter zurücksetzen',
    shopOnline: 'Produkte ansehen',
    todayOpen: 'Heute geöffnet: {{hours}}',
    todayClosed: 'Heute geschlossen',
    hours: 'Öffnungszeiten',
    closed: 'Geschlossen',
    meters: '{{value}} m',
    km: '{{value}} km',
    directions: 'Route',
    directionsTo: 'Route zu {{name}} (Google Maps, öffnet in neuem Tab)',
    mapNote: 'Die Karte ist eine visuelle Übersicht; dieselben Angaben stehen in Filter und Liste.',
    osmAttribution: 'Einige Standorte wurden anhand der Adressen ermittelt: © OpenStreetMap-Mitwirkende',
    allTurkey: 'Ganze Türkei',
    showMap: 'Auf Karte zeigen',
    hideMap: 'Karte ausblenden',
    byCity: 'Nach Provinz',
    byDistrict: 'Bezirke',
    regions: 'Regionen',
  },
  product: 'Produkt',
  products: 'Produkte',
  profile: 'Profil',
  quantity: 'Menge',
  register: 'Konto erstellen',
  registerTitle: 'Konto erstellen',
  remove: 'Entfernen',
  removeCoupon: 'Gutscheincode {{code}} entfernen',
  requestNewLink: 'Fordern Sie einen neuen Link an.',
  resetSent: 'Falls ein Konto mit dieser E-Mail-Adresse existiert, wurde ein Link gesendet.',
  resetTitle: 'Neues Passwort festlegen',
  resetUnavailable:
    'Der E-Mail-Versand ist derzeit nicht verfügbar. Bitte wenden Sie sich an den Shop, um Ihr Passwort zurückzusetzen.',
  resultCount: '{{count}} Produkte',
  save: 'Speichern',
  savePassword: 'Passwort speichern',
  saved: 'Gespeichert.',
  search: 'Suchen',
  searchPlaceholder: 'Produkte oder Inhaltsstoffe suchen',
  searchResults: 'Ergebnisse für "{{q}}"',
  sendLink: 'Link senden',
  shipping: 'Versand',
  shippingLater: 'Wird bei der Bestellung festgelegt',
  signIn: 'Anmelden',
  signInTitle: 'Anmelden',
  signOut: 'Abmelden',
  skipToContent: 'Zum Inhalt springen',
  sku: 'Artikelnr.: {{sku}}',
  sort: 'Sortierung',
  species: 'Tierart',
  status: 'Status',
  submitApplication: 'Bewerbung absenden',
  subtotal: 'Zwischensumme',
  summary: 'Bestellübersicht',
  taxExcluded: 'zzgl. MwSt.',
  taxIncluded: 'inkl. MwSt.',
  taxIncludedLine: 'Enthaltene MwSt.',
  taxLine: 'MwSt.',
  total: 'Gesamt',
  unavailableItem: 'Nicht verfügbares Produkt',
  verifyTitle: 'E-Mail-Bestätigung',
  viewOrder: 'Bestellung anzeigen',
  proceedToCheckout: 'Zur Kasse gehen',
  shippingAtCheckout: 'Wird an der Kasse berechnet',
  checkoutTitle: 'Kasse',
  contactTitle: 'Kontaktdaten',
  contactLead: 'Bestell- und Versandinformationen werden an diese Adresse gesendet.',
  memberCheckoutHint:
    'Sie haben ein Konto? Melden Sie sich an, um Ihre Bestellungen in Ihrem Konto zu sehen.',
  phone: 'Telefon',
  deliveryTitle: 'Lieferadresse',
  newAddress: 'Andere Adresse eingeben',
  billingTitle: 'Rechnungsdaten',
  billingSame: 'Rechnungsadresse entspricht der Lieferadresse',
  corporateInvoice: 'Rechnung an eine Firma',
  shippingTitle: 'Versand',
  free: 'Kostenlos',
  freeOver: 'Kostenlos für Bestellungen ab {{amount}}',
  estimatedDays: 'Voraussichtliche Lieferung: {{days}} Werktage',
  shippingNotAvailable: 'Für diesen Warenkorb nicht verfügbar',
  paymentTitle: 'Zahlungsart',
  installmentsUpTo: 'Bis zu {{count}} Raten',
  codFee: 'Nachnahmegebühr',
  codFeeHint: 'Servicegebühr: {{fee}}',
  codMaxHint: 'Für Bestellungen bis {{amount}}',
  codNotForShipping: 'Mit der gewählten Versandart nicht verfügbar',
  creditAvailable: 'Verfügbares Limit auf offenem Konto: {{amount}}',
  creditOverdueBlock: 'Das offene Konto ist nicht verfügbar, da Sie überfällige Schulden haben ({{amount}}).',
  creditCurrencyBlock: 'Das offene Konto ist in dieser Währung nicht verfügbar.',
  quantityRule: 'Händlerbestellung: mindestens {{min}}, in Vielfachen von {{step}}.',
  itemBelowMin: 'Mindestens {{min}} erforderlich.',
  itemNotMultiple: 'Muss ein Vielfaches von {{step}} sein.',
  minOrderNotMet:
    'Der Mindestbestellwert für Händler beträgt {{min}}. Fügen Sie noch {{missing}} hinzu, um zu bestellen.',
  approval: {
    title: 'Die Freigabe der verantwortlichen Person der Firma ist erforderlich',
    request: 'Zur Freigabe an die verantwortliche Person senden',
    noteLabel: 'Notiz an die verantwortliche Person (optional)',
    send: 'Zur Freigabe senden',
    pending:
      'Am {{date}} zur Freigabe an die verantwortliche Person gesendet; Freigabe ausstehend. Wenn Sie den Warenkorb ändern, wird die Anfrage ungültig.',
    withdraw: 'Anfrage zurückziehen',
    rejected: '{{name}} hat den Warenkorb abgelehnt.',
    reason: 'Grund: {{reason}}',
    stale:
      'Der Warenkorb hat sich nach dem Senden zur Freigabe geändert; senden Sie den aktuellen Warenkorb erneut.',
    approved:
      '{{name}} hat diesen Warenkorb am {{date}} freigegeben. Sie können die Bestellung abschließen, solange der Warenkorb unverändert bleibt.',
    note: 'Notiz: {{note}}',
    ownerTitle: 'Bestellungen, die auf Freigabe warten',
    ownerLead:
      'Warenkörbe von Einkäufern, die deren Bestellschwelle überschreiten. Der Einkäufer gibt den freigegebenen Warenkorb über seine Kasse auf.',
    nonePending: 'Keine Bestellungen warten auf Freigabe.',
    requestOf: 'Freigabeanfrage von {{name}}',
    goodsTotal: 'Warenwert: {{total}}',
    requestNote: 'Notiz: {{note}}',
    approve: 'Freigeben',
    reject: 'Ablehnen',
    rejectReason: 'Grund der Ablehnung',
    rejectSubmit: 'Mit Begründung ablehnen',
    approvedDone: 'Der Warenkorb von {{name}} wurde freigegeben.',
    rejectedDone: 'Der Warenkorb von {{name}} wurde abgelehnt.',
    history: 'Entschiedene Anfragen',
    requester: 'Angefragt von',
    statuses: {
      pending: 'Wartend',
      approved: 'Freigegeben',
      rejected: 'Abgelehnt',
      cancelled: 'Zurückgezogen',
      used: 'Bestellt',
    },
    orderLine: 'Firmenfreigabe: {{name}}',
  },
  po: {
    title: 'Bestellschein (PO)',
    lead: {
      none: 'Optional: Sie können die Bestellscheinnummer und das Dokument Ihrer Firma hinzufügen.',
      number: 'Ihre Firma verlangt bei Bestellungen eine Bestellscheinnummer (PO).',
      number_and_document:
        'Ihre Firma verlangt bei Bestellungen eine Bestellscheinnummer (PO) und ein Dokument.',
    },
    number: 'PO-Nummer',
    numberOptional: 'PO-Nummer (optional)',
    document: 'PO-Dokument',
    documentOptional: 'PO-Dokument (optional)',
    documentHint: 'PDF, JPEG oder PNG; bis zu 10 MB. Nur der Shop kann das Dokument sehen.',
    uploaded: '{{name}} angehängt.',
    remove: 'Entfernen',
    missing: 'Vervollständigen Sie die Bestellscheinangaben, um die Bestellung zu bestätigen.',
    listLabel: 'PO: {{number}}',
    orderLine: 'Bestellschein: {{number}}',
    orderDocument: 'Dokument: {{name}}',
  },
  quotes: {
    title: 'Angebote',
    linkLead: 'Von Ihnen angefragte oder erhaltene Preisangebote',
    detailTitle: 'Angebot {{number}}',
    empty:
      'Noch keine Angebote. Verwenden Sie im Warenkorb "Angebot anfordern", um nach einem Preis zu fragen.',
    number: 'Angebotsnr.',
    validUntil: 'Gültig bis',
    validUntilLine: 'gültig bis {{date}}',
    versionLine: 'Version {{version}}',
    statuses: {
      requested: 'Anfrage eingegangen',
      draft: 'In Vorbereitung',
      sent: 'Wartet auf Ihre Antwort',
      ordered: 'Bestellt',
      rejected: 'Abgelehnt',
      cancelled: 'Storniert',
      expired: 'Abgelaufen',
    },
    requestedLead: 'Ihre Anfrage ist eingegangen. Das Angebot erscheint hier, sobald der Shop es sendet.',
    draftLead:
      'Der Shop erstellt oder aktualisiert das Angebot; Sie können es annehmen, sobald es gesendet wurde.',
    rejectedLead: 'Sie haben das Angebot abgelehnt: {{reason}}',
    expiredLead:
      'Das Angebot ist abgelaufen und kann nicht angenommen werden. Wenden Sie sich für ein neues Angebot an den Shop.',
    note: 'Notiz des Shops',
    requestNoteLine: 'Ihre Notiz: {{note}}',
    lines: 'Angebotene Produkte',
    product: 'Produkt',
    listPrice: 'Listenpreis',
    unitPrice: 'Angebotspreis',
    taxIncl: 'inkl. MwSt.',
    taxExcl: 'zzgl. MwSt.',
    taxLine: 'MwSt.: {{tax}}',
    saving: 'Rabatt gegenüber Listenpreis: {{amount}}',
    shippingNote: 'Versand und Zahlung werden bei der Bestellung gewählt.',
    accept: 'Annehmen und bestellen',
    acceptLead:
      'Beim Annehmen wird Ihr Warenkorb durch dieses Angebot ersetzt (andere Artikel werden entfernt) und Sie gelangen zur Kasse; es gelten die Angebotspreise.',
    reject: 'Ablehnen',
    rejectReason: 'Grund',
    confirmReject: 'Angebot ablehnen',
    print: 'Drucken',
    view: 'Angebot ansehen',
    inCart:
      'Der Warenkorb enthält das Angebot {{number}} (Version {{version}}, gültig bis {{date}}). Es gelten die Angebotspreise; der Warenkorb kann nicht geändert werden.',
    release: 'Angebot aus dem Warenkorb entfernen',
    request: 'Angebot anfordern',
    requestLead:
      'Bitten Sie den Shop um einen Sonderpreis für die Artikel in Ihrem Warenkorb. Ihr Warenkorb bleibt unverändert; das Angebot erscheint unter Mein Konto → Angebote.',
    requestNote: 'Ihre Notiz (optional)',
    sendRequest: 'Angebotsanfrage senden',
    requested: 'Angebotsanfrage {{number}} ist eingegangen.',
  },
  quickOrder: {
    title: 'Schnellbestellung',
    linkLead: 'Sammelbestellung nach Artikelnummer und Menge',
    lead: 'Schreiben Sie pro Zeile eine Artikelnummer und eine Menge (z. B. "ZG-OM-60;12"). Sie können zwei Spalten aus Excel einfügen oder eine CSV-Datei wählen. Prüfen Sie zuerst; gültige Zeilen werden in den Warenkorb gelegt.',
    lines: 'Artikelnummer und Menge (ein Produkt pro Zeile)',
    file: 'oder eine CSV-Datei wählen',
    check: 'Prüfen',
    addToCart: '{{count}} Produkte in den Warenkorb legen',
    preview: 'Prüfergebnis',
    sku: 'Artikelnr.',
    product: 'Produkt',
    unitPrice: 'Stückpreis',
    ok: 'Kann hinzugefügt werden',
    added: '{{count}} Produkte wurden in den Warenkorb gelegt.',
    empty: 'Keine lesbaren Zeilen. Schreiben Sie in jede Zeile eine Artikelnummer und eine Menge.',
    badLines: 'Nicht lesbare Zeilen übersprungen: {{lines}} (Menge muss 1–999 betragen).',
    dealersOnly: 'Die Schnellbestellung steht Händlerkonten zur Verfügung.',
    statuses: {
      not_found: 'Artikelnummer nicht gefunden',
      unavailable: 'Nicht im Verkauf',
      insufficient_stock: 'Nicht genügend Bestand (bis zu {{available}})',
      below_min_quantity: 'Mindestens {{min}}',
      not_pack_multiple: 'Vielfache von {{step}}',
      cart_line_limit: 'Der Warenkorb fasst bis zu {{max}} verschiedene Produkte',
    },
  },
  reorder: {
    title: 'Erneut bestellen',
    button: 'Diese Bestellung wiederholen',
    added: '{{count}} Produkte wurden zu den heutigen Preisen in den Warenkorb gelegt.',
  },
  companyLocation: 'Firma: {{label}}',
  companyInvoiceNote: 'Die Rechnung wird mit Firmenname, Finanzamt und Steuernummer ausgestellt.',
  memberLimit:
    'Ihre Bestellschwelle: {{amount}} (inkl. Versand). Bestellungen darüber benötigen die Freigabe der verantwortlichen Person der Firma.',
  company: {
    title: 'Meine Firma',
    roles: {
      owner: 'Verantwortliche Person',
      buyer: 'Einkäufer',
      viewer: 'Nur Ansicht',
    },
    roleHelp: {
      owner:
        'Sie bestellen für die Firma, sehen Firmenbestellungen, Kontoauszug und Benutzer und verwalten Standorte.',
      buyer: 'Sie bestellen für die Firma und sehen Ihre eigenen Bestellungen.',
      viewer: 'Sie sehen Händlerpreise, Firmenbestellungen und den Kontoauszug; Sie können nicht bestellen.',
    },
    locations: 'Standorte (Filiale, Lieferung, Rechnung)',
    noLocations: 'Noch keine Standorte.',
    addLocation: 'Standort hinzufügen',
    editLocation: 'Standort bearbeiten',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    confirmDelete: 'Standort "{{name}}" löschen? Adressen in früheren Bestellungen ändern sich nicht.',
    deleted: 'Standort gelöscht.',
    saved: 'Standort gespeichert.',
    locationLabel: 'Standortname (z. B. Hauptsitz)',
    defaultShipping: 'Standard-Lieferadresse',
    defaultBilling: 'Standard-Rechnungsadresse',
    makeDefaultShipping: 'Als Standard-Lieferadresse festlegen',
    makeDefaultBilling: 'Als Standard-Rechnungsadresse festlegen',
    saveLocation: 'Standort speichern',
    members: 'Firmenbenutzer',
    membersLead:
      'Um jemanden hinzuzufügen, der im Shop bereits ein Konto hat, oder um Ihre eigene Rolle zu ändern, wenden Sie sich an den Shop.',
    memberName: 'Benutzer',
    role: 'Rolle',
    limit: 'Bestellschwelle',
    notActivated: 'noch nicht aktiviert',
    actions: 'Aktionen',
    you: '(Sie)',
    memberEdit: 'Bearbeiten',
    memberEditFor: 'Bearbeiten: {{name}}',
    memberFormFor: '{{name}}: Rolle und Schwelle',
    memberSave: 'Speichern',
    memberSaved: '{{name}} wurde aktualisiert.',
    remove: 'Aus der Firma entfernen',
    removeFor: 'Aus der Firma entfernen: {{name}}',
    removeConfirm:
      '{{name}} aus der Firma entfernen? Das Konto wird nicht gelöscht, sieht aber keine Händlerpreise und Firmendaten mehr.',
    removed: '{{name}} wurde aus der Firma entfernt.',
    resendLink: 'Link erneut senden',
    resendLinkFor: 'Link erneut senden: {{name}}',
    linkResent: 'An {{email}} wurde ein neuer Aktivierungslink gesendet; der vorherige Link ist ungültig.',
    limitField: 'Bestellschwelle (TRY)',
    limitHint: 'Warenkörbe über diesem Betrag kommen zu Ihnen zur Freigabe. Leer lassen für keine Schwelle.',
    limitInvalid: 'Geben Sie den Betrag wie 5.000 oder 2.500,50 ein.',
    inviteTitle: 'Benutzer einladen',
    inviteLead:
      'Die eingeladene Person erhält per E-Mail einen Aktivierungslink und legt ihr Passwort selbst fest. Sie können bis zu {{perDay}} Einladungen pro Tag senden.',
    inviteName: 'Vor- und Nachname',
    inviteEmail: 'E-Mail',
    invitePhone: 'Telefon (optional)',
    inviteSubmit: 'Einladung senden',
    invited: 'Einladung an {{email}} gesendet.',
    inviteSetupRequired:
      'Einrichtung erforderlich: Einladungen können noch nicht gesendet werden, weil der E-Mail-Versand des Shops nicht eingerichtet ist. Wenden Sie sich an den Shop, um Benutzer hinzuzufügen.',
    orders: 'Firmenbestellungen',
    placedBy: 'Aufgegeben von',
    companyOrderNote:
      'Diese Bestellung gehört einem anderen Benutzer Ihrer Firma; Sie können sie nur ansehen. Rücksendungen und Zahlungen wickelt die Person ab, die sie aufgegeben hat.',
  },
  balancePay: {
    open: 'Mit Karte bezahlen',
    title: 'Saldo per Karte bezahlen',
    modeBalance: 'Gesamter Saldo ({{amount}})',
    modeItems: 'Ausgewählte Posten',
    modeCustom: 'Anderer Betrag',
    itemLabel: '{{item}} — {{amount}}',
    amountLabel: 'Betrag ({{currency}})',
    amountHint: 'Sie können höchstens {{max}} bezahlen.',
    amountInvalid: 'Geben Sie den Betrag im Format 1.250,50 ein.',
    lead: 'Die Zahlung erfolgt auf der sicheren Seite des Zahlungsdienstleisters (bis zu {{installments}} Raten). Sie wird auf Ihrem Kundenkonto verbucht und mit Ihrer ältesten fälligen Schuld verrechnet.',
    submit: '{{amount}} bezahlen',
    unavailable:
      'Kartenzahlung ist derzeit nicht verfügbar. Sie können Ihren Saldo per Banküberweisung begleichen.',
    recent: 'Ihre letzten Kartenzahlungen',
    amount: 'Betrag',
    status: 'Status',
    statuses: {
      pending: 'Ausstehend',
      captured: 'Eingegangen',
      failed: 'Fehlgeschlagen',
      expired: 'Abgelaufen',
      requires_action: 'In Prüfung',
    },
    resultTitle: 'Zahlung auf Kundenkonto',
    notFound: 'Zahlung nicht gefunden.',
    result: {
      pending: 'Ihre Zahlung wird geprüft…',
      captured: 'Ihre Zahlung über {{amount}} ist eingegangen und wurde auf Ihrem Kundenkonto verbucht.',
      failed:
        'Die Zahlung ist fehlgeschlagen. Ihre Karte wurde nicht belastet; Sie können es erneut versuchen.',
      expired:
        'Die Zahlung wurde nicht abgeschlossen. Ihre Karte wurde nicht belastet; Sie können es erneut versuchen.',
      requires_action:
        'Ihre Zahlung wird geprüft. Das Ergebnis erscheint in Ihrem Kundenkonto; bei Bedarf kontaktieren wir Sie.',
    },
    backToAccount: 'Zurück zu meinem Kundenkonto',
  },
  dealerLedger: {
    bhPendingPayments: 'Ihre Zahlungen, die noch nicht in der Buchhaltung erfasst sind',
    bhPending: 'Bestellungen, die noch nicht in unserer Buchhaltung erfasst sind',
    bhSource: 'Saldo und Bewegungen aus unserer Buchhaltung (BizimHesap), zuletzt aktualisiert am {{date}}.',
    bhNever: 'Die Buchhaltungsdaten (BizimHesap) wurden noch nicht abgerufen.',
    bhStale: 'Aktualisierung derzeit nicht möglich; es wird der zuletzt empfangene Stand angezeigt.',
    bhStatement: 'Kontoauszug (Buchhaltung)',
    siteStatement: 'Bestell- und Zahlungsbewegungen auf dieser Website',
    title: 'Mein Kontoauszug',
    lead: 'Bestellungen auf offenem Konto sind {{days}} Tage nach dem Bestelldatum fällig. Zahlungen werden zuerst mit dem ältesten fälligen Betrag verrechnet.',
    leadNoTerm: 'Zahlungen werden zuerst mit dem ältesten fälligen Betrag verrechnet.',
    balance: 'Saldo (offener Betrag)',
    overdue: 'Überfällig',
    available: 'Verfügbares Limit auf offenem Konto',
    openItems: 'Unbezahlte Posten',
    item: 'Bestellung / Buchung',
    dueDate: 'Fälligkeitsdatum',
    open: 'Restbetrag',
    daysOverdue: '{{days}} Tage überfällig',
    statement: 'Kontoauszug (letzte 12 Monate)',
    date: 'Datum',
    description: 'Beschreibung',
    debit: 'Soll',
    credit: 'Haben',
    running: 'Saldo',
    broughtForward: 'Übertrag',
    download: 'Kontoauszug herunterladen (CSV)',
    kinds: {
      order: 'Bestellung',
      order_change: 'Bestelländerung',
      order_payment: 'Bestellzahlung',
      payment: 'Zahlung',
      opening: 'Anfangssaldo',
      adjustment: 'Korrektur',
      reversal: 'Korrektur (Stornobuchung)',
    },
    reasons: {
      placed: 'Bestellung aufgegeben',
      cancelled: 'Storniert',
      partial_cancel: 'Teilweise storniert',
      edited: 'Bestellung bearbeitet',
      refunded: 'Erstattung',
      paid: 'Zahlung eingegangen',
      refund_paid: 'Erstattung ausgezahlt',
      changed: 'Betrag geändert',
      card_balance: 'Kartenzahlung',
    },
  },
  contractsTitle: 'Vorvertragliche Informationen und Vertrag',
  contractsLead:
    'Lesen Sie die folgenden Texte, bevor Sie die Bestellung bestätigen. Die akzeptierten Texte werden mit Ihrer Bestellung gespeichert; Sie können sie jederzeit auf Ihrer Bestellseite einsehen.',
  fillToSeeContracts:
    'Beträge und Vertragstexte erscheinen hier, sobald Sie Adresse, Versandart und Zahlungsart gewählt haben.',
  quoteUpdating: 'Beträge werden aktualisiert…',
  confirmAndPay: 'Bestätigen und bezahlen · {{total}}',
  confirmOrder: 'Bestellung bestätigen · {{total}}',
  placingOrder: 'Ihre Bestellung wird aufgegeben…',
  orderReceivedTitle: 'Ihre Bestellung ist eingegangen',
  orderReceivedLead: 'Ihre Bestellnummer lautet {{number}}.',
  customerService: 'Kundenservice',
  contactPageTitle: 'Kontakt',
  contactForm: {
    title: 'Schreiben Sie uns',
    presets: {
      name: 'Ihr vollständiger Name',
      email: 'Ihre E-Mail-Adresse',
      phone: 'Telefon',
      message: 'Ihre Nachricht',
    },
    submit: 'Senden',
    sent: 'Ihre Nachricht ist eingegangen. Wir antworten Ihnen so schnell wie möglich per E-Mail.',
    trap: 'Dieses Feld leer lassen',
  },
  formChoose: 'Bitte wählen',
  formPrivacy:
    'Ihre personenbezogenen Daten werden ausschließlich zur Beantwortung Ihrer Anfrage verarbeitet. Details:',
  phoneLabel: 'Telefon',
  emailLabel: 'E-Mail',
  contactOrderHint:
    'Wenn Sie wegen einer Bestellung schreiben, geben Sie bitte Ihre Bestellnummer an. Zu Ihrer Bestellung:',
  orderLookupTitle: 'Bestellung abfragen',
  stockAlert: {
    open: 'Benachrichtigen, wenn verfügbar',
    lead: 'Wir senden Ihnen einmalig eine E-Mail, sobald diese Variante wieder vorrätig ist. Kein Konto erforderlich.',
    email: 'E-Mail',
    notice:
      'Ihre Adresse wird nur für diese Benachrichtigung verwendet; Sie erhalten eine einzige E-Mail, sobald das Produkt wieder vorrätig ist, und die Anfrage gilt 6 Monate. Es wird keine Werbung versendet.',
    submit: 'Benachrichtigen',
    sent: 'Erledigt. Wir senden Ihnen eine E-Mail, sobald das Produkt wieder vorrätig ist.',
  },
  tender: {
    title: 'Geschenkkarte oder Shop-Guthaben',
    giftCard: 'Geschenkkartencode',
    apply: 'Anwenden',
    remove: 'Karte entfernen',
    applied: 'Geschenkkarte …{{last4}} angewendet (Guthaben {{balance}}).',
    useCredit: 'Mein Shop-Guthaben verwenden ({{balance}})',
    coveredHint: 'Wird der gesamte Betrag gedeckt, wird die gewählte Zahlungsart nicht verwendet.',
    giftCardLine: 'Geschenkkarte (…{{last4}})',
    storeCreditLine: 'Shop-Guthaben',
    due: 'Zu zahlender Betrag',
    confirmCovered: 'Bestellung bestätigen (kein Restbetrag)',
  },
  credit: {
    title: 'Mein Shop-Guthaben',
    lead: 'Lösen Sie Ihr Shop-Guthaben an der Kasse über „Mein Shop-Guthaben verwenden“ ein.',
    history: 'Guthabenverlauf',
    date: 'Datum',
    kind: 'Vorgang',
    amount: 'Betrag',
    kinds: {
      grant: 'Vom Shop hinzugefügt',
      refund: 'Erstattung als Guthaben gutgeschrieben',
      redeem: 'Für eine Bestellung verwendet',
      release: 'Aus stornierter Bestellung zurückgebucht',
      adjust: 'Korrektur',
    },
  },
  loyalty: {
    tierLine: '{{tier}}-Mitgliederrabatt ({{percent}} %)',
    tierShipping: '{{tier}}-Mitgliedschaft: kostenloser Versand',
    usePoints: 'Meine Punkte einlösen ({{points}} Punkte = {{value}})',
    minRedeem: 'Zum Einlösen benötigen Sie mindestens {{points}} Punkte (Sie haben {{balance}}).',
    pointsLine: 'Treuepunkte ({{points}} Punkte)',
    earn: 'Mit dieser Bestellung sammeln Sie {{points}} Punkte; sie werden {{days}} Tage nach der Lieferung gutgeschrieben.',
    earnNow:
      'Mit dieser Bestellung sammeln Sie {{points}} Punkte; sie werden nach der Lieferung gutgeschrieben.',
    title: 'Meine Punkte',
    balance: '{{points}} Punkte',
    balanceValue: 'Im Wert von {{value}}; lösen Sie sie an der Kasse über „Meine Punkte einlösen“ ein.',
    tier: 'Ihre Stufe: {{tier}}',
    noTier: 'Sie haben noch keine Stufe.',
    perks: 'Ihre Vorteile: {{perks}}',
    perkDiscount: '{{percent}} % Rabatt',
    perkShipping: 'kostenloser Versand',
    nextTier: 'Noch {{amount}} bis zur Stufe {{tier}} ({{spent}} Einkaufswert in den letzten 12 Monaten).',
    topTier: 'Sie haben die höchste Stufe erreicht ({{spent}} Einkaufswert in den letzten 12 Monaten).',
    expiring: '{{points}} Punkte verfallen innerhalb von 30 Tagen.',
    rules: 'Programmbedingungen',
    ruleEarn:
      'Für je {{one}} Einkaufswert erhalten Sie {{points}} Punkte (ohne Versand und ohne den mit Punkten bezahlten Anteil).',
    ruleValue: '{{points}} Punkte = {{one}}.',
    ruleHold: 'Punkte werden {{days}} Tage nach der Lieferung gutgeschrieben.',
    ruleHoldNow: 'Punkte werden nach der Lieferung gutgeschrieben.',
    ruleExpiry:
      'Gesammelte Punkte sind {{months}} Monate gültig; zuerst verfallende Punkte werden zuerst eingelöst.',
    ruleNoExpiry: 'Punkte verfallen nicht.',
    ruleMin: 'Zum Einlösen an der Kasse sind mindestens {{points}} Punkte erforderlich.',
    ruleRefund:
      'Punkte für erstattete Beträge werden zurückgebucht; bei einer stornierten Bestellung eingelöste Punkte werden wiederhergestellt.',
    tiersTitle: 'Stufen (nach Einkaufswert der letzten 12 Monate)',
    tierRow: '{{tier}}: ab {{min}}',
    history: 'Punkteverlauf',
    date: 'Datum',
    kind: 'Vorgang',
    points: 'Punkte',
    kinds: {
      earn: 'Gesammelt',
      redeem: 'Für Bestellung eingelöst',
      release: 'Wiederhergestellt',
      reverse: 'Zurückgebucht (Erstattung)',
      expire: 'Verfallen',
      adjust: 'Korrektur',
    },
  },
  referral: {
    title: 'Freunde einladen',
    lead: 'Ein Freund, der seine erste Bestellung mit Ihrem Einladungscode aufgibt, erhält {{friend}}. {{days}} Tage nach Zustellung der Bestellung Ihres Freundes erhalten Sie einen Gutscheincode über {{referrer}}.',
    leadNow:
      'Ein Freund, der seine erste Bestellung mit Ihrem Einladungscode aufgibt, erhält {{friend}}. Sobald die Bestellung Ihres Freundes zugestellt ist, erhalten Sie einen Gutscheincode über {{referrer}}.',
    offerPercent: '{{percent}} % Rabatt',
    offerFixed: '{{value}} Rabatt',
    offerMin: '{{offer}} (ab einem Bestellwert von {{min}})',
    getCode: 'Einladungscode abrufen',
    yourCode: 'Ihr Einladungscode:',
    link: 'Ihr Einladungslink',
    copy: 'Link kopieren',
    share: 'Teilen',
    shareTitle: 'Mein Einladungslink für einen Rabatt auf die erste Bestellung',
    copied: 'Link kopiert.',
    copyFailed: 'Kopieren fehlgeschlagen; markieren Sie den Link und kopieren Sie ihn selbst.',
    stats: 'Offene Einladungen: {{pending}}. Erhaltene Prämien: {{rewarded}}.',
    rules: 'Programmbedingungen',
    ruleFirst:
      'Der Rabatt gilt nur für die erste Bestellung Ihres Freundes. Ihren eigenen Code können Sie nicht verwenden.',
    ruleHold:
      'Die Prämie wird {{days}} Tage nach Zustellung der Bestellung Ihres Freundes vergeben. Wird die Bestellung storniert oder zurückgesendet, entfällt die Prämie.',
    ruleHoldNow:
      'Die Prämie wird vergeben, sobald die Bestellung Ihres Freundes zugestellt ist. Wird die Bestellung storniert oder zurückgesendet, entfällt die Prämie.',
    ruleValid:
      'Der Prämien-Gutscheincode ist {{days}} Tage gültig und kann nur mit Ihrem Konto verwendet werden.',
    ruleMax: 'Sie können bis zu {{max}} Prämien erhalten.',
    ruleNoContact: 'Der Shop kontaktiert Ihren Freund nie in Ihrem Namen; Sie teilen den Link selbst.',
    rewardsTitle: 'Ihre Prämien-Gutscheincodes',
    code: 'Code',
    discount: 'Rabatt',
    endsAt: 'Gültig bis',
    state: 'Status',
    states: {
      active: 'Verfügbar',
      used: 'Eingelöst',
      expired: 'Abgelaufen',
    },
    inviteTitle: 'Sie wurden eingeladen',
    inviteLead: 'Ein Freund hat Sie eingeladen. Sie erhalten {{offer}} auf Ihre erste Bestellung.',
    inviteCode: 'Einladungscode:',
    inviteHow:
      'Der Code wird automatisch in Ihrem Warenkorb angewendet; Sie können ihn auch selbst in das Feld „Gutscheincode“ im Warenkorb eingeben. Der Rabatt gilt nur für die erste Bestellung.',
    inviteStart: 'Jetzt einkaufen',
  },
  support: {
    title: 'Meine Support-Tickets',
    empty: 'Sie haben noch keine Support-Tickets.',
    newTicket: 'Neues Ticket',
    colTicket: 'Ticket',
    colStatus: 'Status',
    colUpdated: 'Letzte Aktualisierung',
    category: 'Thema',
    subject: 'Betreff',
    order: 'Zugehörige Bestellung (optional)',
    noOrder: 'Keine Bestellung',
    message: 'Ihre Nachricht',
    messageHint:
      'Geben Sie keine Kartennummern, Passwörter oder Bestätigungscodes ein; wir fragen niemals danach.',
    submit: 'Ticket senden',
    cancel: 'Abbrechen',
    categories: {
      order: 'Bestellung',
      shipping: 'Versand und Zustellung',
      return: 'Rücksendung und Umtausch',
      payment: 'Zahlung und Rechnung',
      product: 'Produktinformationen',
      account: 'Konto',
      other: 'Sonstiges',
    },
    statuses: {
      open: 'In Prüfung',
      waiting: 'Wartet auf Ihre Antwort',
      resolved: 'Gelöst',
      closed: 'Geschlossen',
    },
    awaitingRating: 'Bitte bewerten Sie unsere Hilfe',
    ticketTitle: 'Support-Ticket #{{number}}',
    orderLine: 'Bestellung {{number}}',
    conversation: 'Verlauf',
    you: 'Sie',
    team: 'Support-Team',
    resolvedNote:
      'Ihr Ticket wurde als gelöst markiert. Falls das Problem weiterhin besteht, schreiben Sie einfach; das Ticket wird dann wieder geöffnet.',
    closedNote:
      'Dieses Ticket ist geschlossen. Für ein neues Anliegen eröffnen Sie unter „Mein Konto“ ein neues Ticket.',
    reply: 'Ihre Antwort',
    sendReply: 'Antwort senden',
    replySent: 'Ihre Antwort wurde gesendet.',
    rateTitle: 'Bewerten Sie unsere Hilfe',
    rateLead: 'Wählen Sie eine Bewertung von 1 (überhaupt nicht zufrieden) bis 5 (sehr zufrieden).',
    score: '{{score}} Punkte',
    comment: 'Ihr Kommentar (optional)',
    sendRating: 'Bewertung senden',
    ratingSent: 'Vielen Dank, Ihre Bewertung ist eingegangen.',
    thanks: 'Vielen Dank für Ihre Bewertung: {{rating}} / 5',
    notFound:
      'Ticket nicht gefunden. Vergewissern Sie sich, dass Sie den vollständigen Link aus der E-Mail verwendet haben; wenn Sie ein Konto haben, melden Sie sich an.',
    keepLink: 'Der Link zu dieser Seite ist persönlich; teilen Sie ihn nicht.',
  },
  chat: {
    launcher: 'Live-Support',
    title: 'Live-Support',
    close: 'Schließen',
    unavailable:
      'Der Live-Support ist derzeit nicht verfügbar. Sie können uns über die Kontaktseite schreiben:',
    nobody: 'Derzeit ist kein Mitarbeiter online. Sie können uns über die Kontaktseite schreiben:',
    sent: 'Ihre Nachricht ist eingegangen und wurde als Support-Ticket gespeichert. Wir antworten an Ihre E-Mail-Adresse.',
    startLead: 'Stellen Sie Ihre Frage; ein Mitarbeiter antwortet in Kürze.',
    offlineLead:
      'Derzeit ist kein Mitarbeiter online. Hinterlassen Sie eine Nachricht, wir antworten per E-Mail.',
    nameOptional: 'Ihr Name (optional)',
    name: 'Ihr Name',
    emailOptional: 'E-Mail (optional)',
    email: 'E-Mail',
    emailHint: 'Falls der Chat unterbrochen wird, können wir Sie unter dieser Adresse erreichen.',
    emailOfflineHint: 'Wir antworten an diese Adresse.',
    message: 'Ihre Nachricht',
    privacy:
      'Geben Sie keine Kartennummern, Passwörter oder Bestätigungscodes ein. Ihre Angaben werden ausschließlich zur Beantwortung Ihrer Frage verarbeitet:',
    start: 'Chat starten',
    leave: 'Nachricht senden',
    messages: 'Chatnachrichten',
    team: 'Support-Team',
    you: 'Sie',
    events: {
      joined: 'Ein Mitarbeiter ist dem Chat beigetreten.',
      closed_visitor: 'Sie haben den Chat beendet.',
      closed_staff: 'Der Mitarbeiter hat den Chat beendet.',
      closed_idle: 'Der Chat wurde wegen Inaktivität beendet.',
      ticket: 'Ihr Chat wurde als Support-Ticket gespeichert; wir melden uns per E-Mail bei Ihnen.',
    },
    waiting: 'Sie sind Nummer {{position}} in der Warteschlange; ein Mitarbeiter ist gleich für Sie da.',
    closedTicket: 'Der Chat wurde beendet; Ihr Anliegen wurde als Support-Ticket gespeichert.',
    closed: 'Der Chat wurde beendet.',
    newChat: 'Neuer Chat',
    yourMessage: 'Ihre Nachricht',
    send: 'Senden',
    end: 'Chat beenden',
  },
  promo: {
    title: 'Aktionen',
    itemDiscount: '{{percent}} % Rabatt im Warenkorb',
    buyXPayY:
      '{{buy}} kaufen, {{pay}} bezahlen: Bei je {{buy}} Artikeln erhalten Sie die {{free}} günstigsten gratis',
    tierSubtotalPercent: '{{percent}} % Rabatt ab einem Warenkorbwert von {{min}}',
    tierSubtotalFixed: '{{value}} Rabatt ab einem Warenkorbwert von {{min}}',
    tierQuantityPercent: '{{percent}} % Rabatt beim Kauf von mindestens {{min}} Artikeln',
    tierQuantityFixed: '{{value}} Rabatt beim Kauf von mindestens {{min}} Artikeln',
    freeShippingOver: 'Kostenloser Versand ab einem Bestellwert von {{min}}',
    freeShipping: 'Kostenloser Versand',
    until: 'Bis {{date}}',
    targeted: 'Die Aktion gilt für dieses Produkt; der Rabatt wird im Warenkorb abgezogen.',
    hintPercent: 'Fügen Sie noch {{amount}} hinzu und erhalten Sie {{percent}} % Rabatt auf Ihren Warenkorb.',
    hintFixed: 'Fügen Sie noch {{amount}} hinzu und erhalten Sie {{value}} Rabatt auf Ihren Warenkorb.',
    hintShipping: 'Fügen Sie noch {{amount}} hinzu für kostenlosen Versand.',
    shippingFree: 'Kostenloser Versand',
    coupon: 'Gutscheincode ({{code}})',
  },
  push: {
    title: 'Browser-Benachrichtigungen',
    lead: 'Erfahren Sie per Benachrichtigung von Aktionen und neuen Produkten. Die Berechtigung wird erst angefragt, wenn Sie auf die Schaltfläche klicken; Sie können sie jederzeit deaktivieren.',
    enable: 'Benachrichtigungen aktivieren',
    disable: 'Benachrichtigungen deaktivieren',
    enabled: 'Benachrichtigungen sind in diesem Browser aktiviert.',
    disabled: 'Benachrichtigungen deaktiviert.',
    denied:
      'Ihr Browser blockiert Benachrichtigungen für diese Website. Ändern Sie die Website-Berechtigung in den Browsereinstellungen, um sie zu aktivieren.',
    failed: 'Benachrichtigungen konnten nicht aktiviert werden. Versuchen Sie es später erneut.',
    privacy: 'Datenschutzhinweis',
  },
  newsletter: {
    title: 'E-Mail-Newsletter',
    lead: 'Erfahren Sie von Angeboten, neuen Produkten und Artikeln. Sie können sich jederzeit mit einem Klick abmelden.',
    email: 'Ihre E-Mail-Adresse',
    consent:
      'Ich willige ein, kommerzielle elektronische Nachrichten per E-Mail zu Angeboten, Ankündigungen und Neuigkeiten zu erhalten.',
    privacy: 'Datenschutzhinweis',
    submit: 'Abonnieren',
    sent: 'Vielen Dank. Öffnen Sie den Link, den wir an Ihre E-Mail-Adresse gesendet haben, um das Abonnement zu starten (7 Tage gültig). Falls keine E-Mail ankommt, prüfen Sie Ihren Spam-Ordner.',
    confirmTitle: 'Newsletter-Abonnement bestätigen',
    confirmLead:
      'Klicken Sie auf die Schaltfläche unten, um uns zu erlauben, den Newsletter an diese Adresse zu senden.',
    confirm: 'Abonnement bestätigen',
    confirmed:
      'Ihr Abonnement ist aktiv. Sie können sich jederzeit über den Link am Ende jedes Newsletters abmelden.',
    missingToken: 'Der Link ist unvollständig. Öffnen Sie den vollständigen Link aus der E-Mail.',
    unsubscribeTitle: 'Von Marketing-Nachrichten abmelden',
    unsubscribeLead: 'Wir senden keine Marketing-Nachrichten mehr an {{address}}.',
    unsubscribeLeadSms: 'Wir senden keine Marketing-SMS mehr an {{address}}.',
    unsubscribe: 'Abmelden',
    unsubscribed:
      'Erledigt: Wir senden keine Marketing-Nachrichten mehr an {{address}}. Bestell- und Versandbenachrichtigungen erhalten Sie weiterhin.',
    memberHint:
      'Wenn Sie ein Konto haben, können Sie Ihre Einstellungen auch in den Nachrichteneinstellungen unter „Mein Konto“ ändern.',
  },
  orderLookupLead:
    'Geben Sie Ihre Bestellnummer und die bei der Bestellung verwendete E-Mail-Adresse ein. Stimmen die Angaben überein, wird Ihnen der Link zu Ihrer Bestellung per E-Mail gesendet.',
  orderLookupMember: 'Wenn Sie als Mitglied bestellt haben, finden Sie Ihre Bestellungen in Ihrem Konto:',
  orderNumber: 'Bestellnummer',
  orderLookupSubmit: 'Link senden',
  orderLookupSent:
    'Wenn die Angaben zu einer Bestellung passen, erhalten Sie den Bestelllink in wenigen Minuten per E-Mail. Andernfalls prüfen Sie Ihren Spam-Ordner.',
  orderLookupUnavailable:
    'Derzeit können keine E-Mails gesendet werden. Bitte kontaktieren Sie uns über die Angaben auf der Kontaktseite.',
  bankAccountsTitle: 'Unsere Bankverbindungen',
  bankAccountsLead:
    'Geben Sie bei der Überweisung Ihre Bestellnummer (oder Händlernummer) als Verwendungszweck an.',
  bankAccountsEmpty: 'Es wurden noch keine Bankverbindungen hinterlegt.',
  returnsTitle: 'Rücksendung, Widerruf und Umtausch',
  returnLead:
    'Um einen Artikel zurückzusenden oder Ihr Widerrufsrecht auszuüben, stellen Sie eine Anfrage; wir prüfen sie und antworten per E-Mail. Bedingungen:',
  returnPolicyLink: 'Rücksende- und Widerrufsbedingungen',
  returnStart: 'Rücksende-/Widerrufsanfrage stellen',
  returnStartExchange: 'Rücksende-, Widerrufs- oder Umtauschanfrage stellen',
  returnResolution: 'Was möchten Sie?',
  returnResolutions: {
    refund: 'Eine Erstattung',
    exchange: 'Einen Umtausch (andere Variante desselben Produkts)',
  },
  exchangeHint:
    'Umgetauscht wird gegen vorrätige Varianten zum gleichen Preis; es fallen keine Zusatzkosten an. Für eine Variante zu einem anderen Preis stellen Sie eine Rücksendeanfrage und geben eine neue Bestellung auf.',
  exchangeItemsLabel: 'Umzutauschende Artikel, Menge und gewünschte Ersatzvariante',
  exchangeFor: 'Gewünschte Variante anstelle von {{title}}',
  exchangeChoose: 'Variante wählen',
  exchangeItems: 'Ersatzlieferung: {{items}}',
  exchangeShipped: 'Der Umtauschartikel wurde versendet. Sendungsnummer: {{number}}',
  cancelledQty: '{{count}} nicht lieferbar und storniert',
  cancelledItems: 'Stornierte Artikel',
  chooseProvince: 'Provinz wählen',
  chooseDistrict: 'Bezirk wählen',
  chooseProvinceFirst: 'Zuerst Provinz wählen',
  returnKind: 'Art der Anfrage',
  returnItems: 'Zurückzusendende Artikel und Mengen',
  returnQuantityFor: 'Rücksendemenge für {{title}}',
  returnNote: 'Anmerkung (optional)',
  returnSubmit: 'Anfrage senden',
  returnSent:
    'Ihre Anfrage ist eingegangen. Nach der Prüfung informieren wir Sie per E-Mail; bitte warten Sie unsere Antwort ab, bevor Sie den Artikel versenden.',
  returnKinds: {
    withdrawal: 'Widerrufsrecht (Meinung geändert)',
    defective: 'Beschädigter / fehlerhafter Artikel',
    wrong_item: 'Falscher Artikel geliefert',
    other: 'Sonstiges',
  },
  returnStatuses: {
    requested: 'In Prüfung',
    approved: 'Genehmigt',
    rejected: 'Nicht angenommen',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
  },
  bankTransferTitle: 'Angaben zur Banküberweisung',
  bankTransferLead:
    'Bitte überweisen Sie {{amount}} auf eines der folgenden Konten und geben Sie Ihre Bestellnummer als Verwendungszweck an. Ihre Bestellung wird vorbereitet, sobald die Zahlung eingegangen ist.',
  bankTransferDeadline:
    'Ist Ihre Zahlung bis {{deadline}} nicht auf unserem Konto eingegangen, wird Ihre Bestellung automatisch storniert.',
  bank: 'Bank',
  accountHolder: 'Kontoinhaber',
  iban: 'IBAN',
  transferDescription: 'Verwendungszweck',
  copy: 'Kopieren',
  copied: 'Kopiert',
  payRedirecting: 'Weiterleitung zur sicheren Zahlungsseite…',
  payFrameTitle: 'Sichere Zahlung',
  payFrameMissing:
    'Das Kartenzahlungsformular konnte nicht geöffnet werden (möglicherweise abgelaufen oder in einem anderen Tab geöffnet). Rufen Sie Ihre Bestellung auf, um die Zahlung erneut zu starten.',
  payFrameLead:
    'Die Kartendaten werden im sicheren Formular des Zahlungsdienstleisters eingegeben; der Shop sieht sie nie.',
  payFrameReturn: 'Weiter zum Zahlungsergebnis',
  paymentInitFailed:
    'Die Zahlungsseite konnte nicht geöffnet werden. Ihre Bestellung ist gespeichert; Sie können es erneut versuchen.',
  retryPayment: 'Zahlung erneut versuchen',
  paymentResultTitle: 'Zahlungsergebnis',
  paymentChecking: 'Ihre Zahlung wird geprüft…',
  paymentSuccess: 'Zahlung eingegangen. Ihre Bestellung wird vorbereitet.',
  paymentAuthorized: 'Ihre Bestellung ist bestätigt.',
  paymentAuthorizedLead:
    'Der Betrag der Bestellung {{number}} ist auf Ihrer Karte reserviert und wird beim Versand der Artikel abgebucht.',
  preauthNote:
    'Der Betrag wird jetzt auf Ihrer Karte reserviert und beim Versand der Artikel abgebucht. Nur Einmalzahlung; funktioniert möglicherweise nicht mit Debitkarten.',
  paymentFailed: 'Die Zahlung konnte nicht abgeschlossen werden.',
  paymentReview:
    'Ihre Zahlung wird vom Zahlungsdienstleister geprüft. Das Ergebnis erscheint auf Ihrer Bestellseite.',
  paymentPendingLong: 'Noch kein Zahlungsergebnis. Prüfen Sie Ihre Bestellseite in einigen Minuten.',
  paymentExpired: 'Die Zahlungsfrist ist abgelaufen; die Bestellung wurde storniert.',
  orderNotFound:
    'Bestellung nicht gefunden. Öffnen Sie den Link genau wie in Ihrer E-Mail oder melden Sie sich in Ihrem Konto an.',
  keepOrderLink: 'Bewahren Sie den Link zu dieser Seite auf: Damit können Sie Ihre Bestellung verfolgen.',
  trackOrder: 'Bestellung verfolgen',
  paymentLabel: 'Zahlung',
  shipmentTitle: 'Sendungsverfolgung',
  trackingNumber: 'Sendungsnummer: {{number}}',
  trackShipment: 'Sendung verfolgen',
  partialShipmentNote:
    'Ein Teil Ihrer Bestellung wurde versendet. Die übrigen Artikel werden in einem separaten Paket verschickt; wir informieren Sie per E-Mail, sobald es versendet wird.',
  shipmentItems: 'In diesem Paket: {{items}}',
  documentsTitle: 'Von Ihnen akzeptierte Texte',
  sellerInfo: 'Angaben zum Verkäufer',
  mersis: 'MERSIS: {{no}}',
  kep: 'KEP: {{address}}',
  paymentSecureIyzico: 'Zahlungen werden sicher über iyzico abgewickelt',
  etbis: 'Bei ETBİS registriert (zum Überprüfen klicken)',
  etbisQr: 'QR-Code der ETBİS-Registrierung',
  consent: {
    title: 'Cookie-Einstellungen',
    lead: 'Cookies, die für den Betrieb der Website erforderlich sind, verwenden wir immer. Mit Ihrer Einwilligung verwenden wir zusätzlich Cookies, um Besuche zu messen (Analyse) und Werbung passend zu Ihren Interessen anzuzeigen (Marketing). Sie können Ihre Auswahl jederzeit über den Link „Cookie-Einstellungen“ unten auf der Seite ändern.',
    policyLink: 'Cookie-Richtlinie',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Ablehnen',
    preferences: 'Einstellungen',
    save: 'Auswahl speichern',
    close: 'Schließen',
    necessary: 'Notwendige Cookies',
    necessaryLead:
      'Für Warenkorb, Anmeldung, Sicherheit und das Speichern dieser Auswahl. Können nicht deaktiviert werden.',
    alwaysOn: 'Immer aktiv',
    analytics: 'Analyse-Cookies',
    analyticsLead: 'Helfen uns zu messen, wie die Website genutzt wird.',
    marketing: 'Marketing-Cookies',
    marketingLead: 'Zur Messung von Werbung und zur Anzeige interessenbezogener Werbung.',
    providers: 'Dienste: {{list}}.',
    providerNames: {
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics',
      googleAds: 'Google Ads',
      meta: 'Meta-Pixel (Facebook, Instagram)',
      tiktok: 'TikTok-Pixel',
    },
    transferNote:
      'Die Anbieter dieser Dienste können Daten außerhalb der Türkei verarbeiten. Einzelheiten finden Sie in der Cookie-Richtlinie und im Datenschutzhinweis.',
    error: 'Ihre Auswahl konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    footerLink: 'Cookie-Einstellungen',
  },
  legalFallbackNote:
    'Dieses Dokument ist noch nicht auf Deutsch veröffentlicht; die türkische Fassung wird angezeigt.',
  legalTemplatedNote:
    'Dies ist ein Muster. Während des Bestellvorgangs wird es mit Ihren Bestelldaten ausgefüllt und Ihnen per E-Mail gesendet.',
  unitPrice: 'Grundpreis: {{price}} / {{unit}}',
  orderShippingMethod: 'Versand: {{name}}',
  billingAddress: 'Rechnungsadresse',
  shippingAddress: 'Lieferadresse',
  cardSummary: '{{brand}} ···· {{last4}}',
  installmentCount: '{{count}} Raten',
  awaitingTransferNote: 'Ihre Bestellung wartet auf die Banküberweisung.',
  awaitingCardNote: 'Ihre Bestellung wartet auf die Kartenzahlung.',
  checkoutBlocked: 'Bestellungen sind derzeit nicht möglich',
  address: {
    fullName: 'Name des Empfängers',
    phone: 'Telefon',
    line1: 'Adresse',
    district: 'Bezirk',
    city: 'Provinz',
    postalCode: 'Postleitzahl (optional)',
    companyName: 'Firmenname',
    taxOffice: 'Finanzamt',
    taxNumber: 'Steuernummer / TCKN',
    cityAbroad: 'Stadt',
    districtAbroad: 'Bundesland / Region (optional)',
    abroadNote:
      'Lieferland: {{country}}. Um in ein anderes Land zu liefern, ändern Sie das Land oben auf der Seite.',
  },
  dealerFields: {
    legalName: 'Offizieller Firmenname',
    tradeName: 'Handelsname (optional)',
    taxOffice: 'Finanzamt',
    taxNumber: 'Steuernummer / TCKN',
    phone: 'Geschäftstelefon',
    city: 'Provinz',
    district: 'Bezirk (optional)',
    address: 'Vollständige Adresse',
    businessType: 'Art des Unternehmens (z. B. Tierarztpraxis)',
    note: 'Ergänzende Angaben (optional)',
  },
  leafletSections: {
    description: 'Über das Produkt',
    specs: 'Technische Daten',
    videos: 'Videos',
    documents: 'Dokumente',
    composition: 'Zusammensetzung',
    usage: 'Anwendung',
    warnings: 'Warnhinweise',
  },
  orderStatuses: {
    draft: 'Entwurf',
    awaiting_payment: 'Zahlung ausstehend',
    paid: 'Bezahlt',
    processing: 'In Bearbeitung',
    shipped: 'Versendet',
    delivered: 'Zugestellt',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
  },
  sorts: {
    relevance: 'Beste Übereinstimmung',
    newest: 'Neueste',
    price_asc: 'Preis (aufsteigend)',
    price_desc: 'Preis (absteigend)',
    name: 'Nach Name',
  },
  paymentMethods: {
    card: 'Kredit-/Debitkarte',
    paypal: 'PayPal',
    bank_transfer: 'Banküberweisung',
    cash_on_delivery: 'Nachnahme',
    open_account: 'Offenes Konto',
    manual: 'Überweisung / Barzahlung (nach Absprache mit dem Shop)',
    gift_card: 'Geschenkkarte',
    store_credit: 'Shop-Guthaben',
    loyalty_points: 'Treuepunkte',
  },
  paymentMethodHints: {
    card: 'Die Kartendaten werden auf der sicheren Seite des Zahlungsdienstleisters eingegeben.',
    paypal: 'Bezahlen Sie mit Ihrem PayPal-Konto auf der sicheren Seite von PayPal.',
    bank_transfer: 'Die Bankverbindung wird nach der Bestellung angezeigt.',
    cash_on_delivery: 'Sie bezahlen bei der Lieferung an den Zusteller.',
    open_account: 'Der Betrag wird Ihrem Händler-Kundenkonto belastet.',
  },
  paymentStatuses: {
    authorized: 'Autorisiert (reserviert)',
    pending: 'Ausstehend',
    requires_action: 'In Prüfung',
    captured: 'Eingegangen',
    failed: 'Fehlgeschlagen',
    cancelled: 'Storniert',
    expired: 'Abgelaufen',
  },
  shipmentStatuses: {
    created: 'In Vorbereitung',
    in_transit: 'Unterwegs',
    out_for_delivery: 'In Zustellung',
    delivered: 'Zugestellt',
    returned: 'Zurückgesendet',
    exception: 'Zustellproblem',
    cancelled: 'Storniert',
  },
  carriers: {
    yurtici: 'Yurtiçi Kargo',
    aras: 'Aras Kargo',
    mng: 'MNG Kargo (DHL eCommerce)',
    ptt: 'PTT Kargo',
    surat: 'Sürat Kargo',
    hepsijet: 'HepsiJET',
    kolaygelsin: 'Kolay Gelsin',
    ups: 'UPS',
    other: 'Versanddienstleister',
  },
  paymentLink: {
    title: 'Zahlung',
    paid: 'Die Zahlung für diese Bestellung ist eingegangen. Vielen Dank.',
    validUntil: 'Dieser Zahlungslink ist bis {{date}} gültig.',
    recipient: 'Empfänger: {{name}} · {{place}}',
    payButton: 'Mit Karte bezahlen',
  },
  legalKinds: {
    kvkk_notice: 'Datenschutzhinweis (KVKK)',
    membership_terms: 'Mitgliedschaftsbedingungen',
    pre_information: 'Formular für vorvertragliche Informationen',
    distance_sales: 'Fernabsatzvertrag',
    return_policy: 'Rücksendung und Widerruf',
    privacy_policy: 'Datenschutzrichtlinie',
    cookie_policy: 'Cookie-Richtlinie',
  },
  units: {
    kg: 'kg',
    l: 'L',
    piece: 'Stück',
  },
  // F7-19: düzenli gönderim
  addressBook: {
    title: 'Meine Adressen',
    lead: 'Lieferadressen, die Sie an der Kasse wählen können. Die regelmäßige Lieferung nutzt Ihre Standard-Lieferadresse.',
    empty: 'Sie haben keine gespeicherten Adressen.',
    add: 'Neue Adresse hinzufügen',
    save: 'Adresse speichern',
    saved: 'Adresse gespeichert.',
    cancel: 'Abbrechen',
    default: 'Standard-Lieferadresse',
    makeDefault: 'Als Standard festlegen',
    defaultSaved: 'Standard-Lieferadresse geändert.',
    setDefault: 'Als meine Standard-Lieferadresse verwenden',
    delete: 'Löschen',
    deleteFor: 'Adresse {{name}}, {{city}} löschen',
    deleteConfirm:
      'Diese Adresse löschen? Bereits gestartete regelmäßige Lieferungen verwenden weiterhin ihre Kopie.',
    deleted: 'Adresse gelöscht.',
  },
  subscription: {
    title: 'Regelmäßig liefern',
    discount: '{{pct}} % Rabatt auf jede regelmäßige Bestellung',
    terms:
      'Ihre erste Bestellung wird sofort angelegt und Sie gelangen zur Zahlungsseite. Weitere Bestellungen werden im gewählten Abstand zum aktuellen Preis angelegt; den Zahlungslink senden wir per E-Mail und zeigen ihn unter „Mein Konto“, Ihre Karte wird nicht gespeichert. Sie können jederzeit überspringen, verschieben oder kündigen.',
    interval: 'Lieferabstand',
    everyWeek: 'Jede Woche',
    every: 'Alle {{n}} Wochen',
    start: 'Regelmäßige Lieferung starten',
    signIn: 'Für regelmäßige Lieferung anmelden',
    addAddress: 'Lieferadresse unter „Mein Konto“ hinzufügen',
  },
  subscriptions: {
    title: 'Meine wiederkehrenden Bestellungen',
    lead: 'Sehen Sie den nächsten Tag Ihrer regelmäßigen Lieferungen; überspringen, verschieben, pausieren oder kündigen Sie sie. Jede Bestellung bestätigen und bezahlen Sie selbst über den Zahlungslink.',
    linkLead: 'Nächste Lieferung, überspringen, verschieben, kündigen',
    signIn: 'Melden Sie sich an, um Ihre wiederkehrenden Bestellungen zu sehen.',
    empty:
      'Sie haben keine wiederkehrenden Bestellungen. Starten Sie eine über das Feld „Regelmäßig liefern“ auf einer Produktseite.',
    statuses: {
      active: 'Aktiv',
      paused: 'Pausiert',
      cancelled: 'Gekündigt',
    },
    reasons: {
      customer: 'Auf Ihren Wunsch',
      unpaid: 'Pausiert, weil zwei Bestellungen in Folge nicht bezahlt wurden',
      unavailable: 'Dieses Produkt wird nicht mehr regelmäßig geliefert',
      panel: 'Vom Shop gekündigt',
      payment_unavailable: 'Der Zahlungslink konnte nicht erstellt werden; bitte wenden Sie sich an den Shop',
    },
    summary: 'Menge: {{quantity}} · {{interval}}',
    next: 'Nächste Bestellung: {{date}}',
    address: 'Lieferung: {{address}}',
    pending: 'Bestellung {{number}} wartet auf Zahlung ({{total}}).',
    pay: 'Jetzt bezahlen',
    redirecting: 'Sie werden zur Zahlungsseite weitergeleitet…',
    saved: 'Lieferabstand aktualisiert.',
    skip: 'Nächste überspringen',
    skipped: 'Nächste Bestellung übersprungen.',
    postponeDate: 'Neues Datum',
    postpone: 'Verschieben',
    postponed: 'Nächste Bestellung verschoben.',
    pause: 'Pausieren',
    paused: 'Regelmäßige Lieferung pausiert.',
    resume: 'Fortsetzen',
    resumed: 'Regelmäßige Lieferung fortgesetzt.',
    cancel: 'Kündigen',
    cancelled: 'Regelmäßige Lieferung gekündigt.',
    cancelConfirm:
      'Diese regelmäßige Lieferung kündigen? Es werden keine neuen Bestellungen angelegt. Eine Bestellung, die auf Zahlung wartet, wird nach Ablauf des Links automatisch storniert.',
  },
};
